<template>
  <el-sub-menu v-if="shouldShow(menu) && menu.children && menu.children.length" :index="menu.path">
    <template #title>
      <!-- <i :class="['el-icon-', menuIcon(menu)]"></i> -->
      <tq-icon :name="menuIcon(menu)"></tq-icon>
      <span class="menu-title-span">{{ menu.meta.name }}</span>
      <div class="tq-menu-dotted-number" v-if="menu.name && menuCountObj[menu.name]">
        <span>{{ menuCountObj[menu.name]  }}</span>
      </div>
    </template>
    <template v-for="(sub, idx) in menu.children" :key="idx">
      <tq-page-aside-menu-item :userMenuPerms="userMenuPerms" :menuCountObj="menuCountObj" :menu="sub"  :is-root="false"></tq-page-aside-menu-item>
    </template>
  </el-sub-menu>
  <!-- 无二级菜单 -->
  <el-menu-item v-else-if="shouldShow(menu)" :index="menu.path">
    <!-- <i :class="['el-icon-', menuIcon(menu)]"></i> -->
    <tq-icon :name="menuIcon(menu)"></tq-icon>
    <template  #title>
      <span class="menu-title-span">{{ menu.meta.name }}</span>
    </template>
    <div class="tq-menu-dotted-number" v-if="menu.name && menuCountObj[menu.name]">
      <span>{{ menuCountObj[menu.name]  }}</span>
    </div>
  </el-menu-item>
</template>


<script lang="ts" setup>
import { ref, computed } from "vue";

type Props = {
  isRoot?: boolean;
  menuCountObj: any;
  userMenuPerms: Array<string>;
  menu: any;
};
const props = withDefaults(defineProps<Props>(), {
  isRoot: true,
  menuCountObj: () => ({}),
  userMenuPerms: () => [],
  menu: {
      resourceIcon: "",
      resourceName: "",
      resourceUrl: "",
  } 
});

const shouldShow = computed(() => {
  return (menu:any) => {
    const meta = menu.meta
    return meta.isMenu && (meta.isPublic === true || props.userMenuPerms.includes(meta.code))
  }
})
const menuIcon = computed(() => {
  return (menu:any) => {
    return menu.meta.icon ? menu.meta.icon : (props.isRoot ? "menu-app" : "menu-circle")
  };
})

defineOptions({
  name: "TqPageAsideMenuItem",
})
</script>